import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

@entity({ type: 'tags' })
export class Tag extends JsonapiEntity<Tag> {
  @attribute() title: string;
  @attribute({ name: 'is_active' }) isActive: boolean;
}
